export default {
  namespaced: true,
  unit: {
    title: "Instalación | Instalaciones",
    single: "instalación",
    all: "todas las instalaciones",
    description: "descripción",
    address_1: "dirección",
    address_2: "referencia",
    exterior_number: "Número Exterior",
    suburb: "Colonia",
    number: "Número Interior",
    postal_code: "C.P",
    route: "Ruta",
    plate_number: "Placa",
    vin: "VIN",
    driver: "Conductor",
    provider: "Proveedor",
    owner: "Concesionario",
    company: "Compañía",
    vehicle: "¿Es vehículo?",
    reaction_patrol: "Patrulla de reacción",
    allow_virtual_button_alarm: "Permitir Botón Virtual",
    active_digital_output: "Permitir Salida Digital",
    camera_count: "Camaras",
    timeZone: "zona horaria",
    example: "ejemplo",
    disable: "Desactivar instalación",
    disable_comment: "Comentario",
    reactivation_date: "Fecha de reactivación",
    deactivation_date: "Fecha de desactivación",
    required_deactivation_catalog: "El campo 'Catálogo de Desactivación de Instalaciones' es obligatorio",
    required_comment: "El campo 'Comentario' es obligatorio",
    location: "Ubicación",
    emergency_contacts: "Contactos de Emergencia",
    title_app: "Instalación SBO Mobile",
    description_app: "Instalación que se utilizará para generar incidentes a través de SBO Mobile",
    category: "Categoría",
    additional_info: "Información Adicional",
    key: "Clave",
    value: "Valor",
    import_from_template: "Importar desde plantilla",
    download_template: "Descargar plantilla",
    add_from_form: "Agregar desde formulario",
    template: "Plantilla",
    select_template: "Seleccionar plantilla",
    search: "Buscar",
    name: 'Nombre',
    phone_number: 'Teléfono',
    section: 'Sección',
    add_contact: 'Añadir contacto',
    remove_contact: 'Eliminar',
    assign_task: 'Asignar tarea',
    task_type: 'Tipo',
    task_type_inmuebles: 'Inmuebles',
    task_type_form: 'Formulario',
    task_type_completar_form: 'Completar formulario',
    task_type_create_form_with_relation: 'Crear formulario con relación',
    assigned_task: 'Asignación de inmueble',
    assigned_form_task: 'Asignación de formulario',
    assigned_task_details: 'Detalles de asignación de inmueble',
    assigned_form_task_details: 'Detalle de asignación de formulario',
    assigned_security_form_task: 'Asignación de formulario de seguridad',
    assigned_security_form_task_details: 'Detalle de asignación de formulario de seguridad',
    panel_failure_task: 'Falla del panel',
    panel_failure_task_hint: 'Arrastra la notificación a un slot para ver la alarma',
    mark_as_done: 'Marcar como realizado',
    zone_number: 'Zona',
    region_label: 'Región',
    task_status: {
      pending: 'Pendiente',
      done: 'Realizado',
      cancelled: 'Cancelado'
    },
    enable_nearby_locations: 'Habilitar ubicaciones cercanas',
    distance: 'Distancia',
    needs_check: 'Permitir ping',
    getLatLng: 'Obtener latitud, longitud y zona horaria de la dirección',
    ip_address: 'Dirección IP',
    subnet_mask: 'Máscara de Subred',
    invalid_ip_format: 'Formato de IP inválido',
    invalid_range: 'Rango inválido',
    ip_required: 'La dirección IP es requerida',
    mask_required: 'La máscara de subred es requerida',
    attachments: 'Archivos Adjuntos (Máximo 3)',
    no_data: 'Sin datos',
    tenant: 'Tenant',
    center: 'Centro',
    sector: 'Sector',
    id_totem: 'ID Totem',
    totem_key: 'Totem Key',
    id_seproban: 'ID Seproban',
    rems: 'REMS',
    sirh: 'SIRH',
    duplicate_facility_title: 'Ya existe una Instalación con este REMS/SIRH',
    open_existing_new_tab: 'Abrir en nueva pestaña el existente',
    merge: 'Realizar Merge',
    duplicate_facility_message: 'Abre la unidad en otra pestaña para editarla, o crea la nueva/actualiza y realiza el merge completo.',
    file_limit_reached: 'Límite alcanzado',
    file_limit_message: 'Solo puedes subir un máximo de 3 archivos',
    invalid_file_type: 'Tipo de archivo no válido',
    invalid_file_message: 'El archivo "{fileName}" no es un formato permitido',
    downloading_file: 'Descargando archivo...',
    last_completed_result: 'Resultado de la última evaluación aprobada',
    reference_number: 'Referencia',
    template_label: 'Plantilla',
    no_completed_evaluations: 'Esta instalación todavía no tiene una evaluación aprobada.',
    no_result_found: 'No se encontraron resultados',
    reverse_geocoder_failed: 'Error en geocodificación inversa',
    bank_data: 'Datos Banco',
    correct_address_warning: "Es importante colocar todos los datos de la dirección para que las coordenadas (Latitud/Longutud/Zona Horaria) sean calculadas con exactitud",
    is_disabled: "¿Esta activado?",
    deactivated_data: "Información de Desactivación",
    entity: "Entidad",
    configuration_date: "Fecha de configuración",
    installation_date: "Fecha de instalación",
    c5_router_label: "Etiqueta C5 Router",
    router_serial_number: "Número de serie router",
    router_model: "Modelo Router",
    router_brand: "Marca Router",
    user: "Usuario",
    password: "Contraseña",
    ip_vpn: "IP VPN",
    mac_address: "Mac Address",
    is_main_unit: "Es instalación principal",
    add_filters: "Añadir filtros",
    toggle_detail_search: "Mostrar u ocultar la búsqueda dentro del detalle",
    is_saturday: "Sabatina",
    id_cashier: "ID cajero"
  },
};
